import styled, { css } from 'styled-components';

export const OverlayableStyled = styled.div<{sizeToParent: boolean}>`
  position: relative;
  display: inline-block;
  ${({ sizeToParent }) => sizeToParent ? css`
    width: 100%;
    height: 100%;
  ` : '' }

  .OverlayContainer {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: none;
  }
`;

export default OverlayableStyled;